import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postMakeMeParent() {
    const { apiPostMakeMeParent } = apiConfig.getStaticUrls();

    return postFetch(apiPostMakeMeParent);
}
